import { render, staticRenderFns } from "./FinesSubManagementPage.vue?vue&type=template&id=5b873016&scoped=true"
import script from "./FinesSubManagementPage.vue?vue&type=script&lang=js"
export * from "./FinesSubManagementPage.vue?vue&type=script&lang=js"
import style0 from "./FinesSubManagementPage.vue?vue&type=style&index=0&id=5b873016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b873016",
  null
  
)

export default component.exports